<template>
	<div class="layout">
		<div class="layout__header">
			<div class="layout__title">
				<h3>Reporte general de cartera</h3>
			</div>
			<div class="layout__controls">
				<div class="form-inline">
					<button @click="exportar" class="btn-success btn--bigger">
						<i class="fa fa-file-excel-o"></i><span>Descargar reporte</span>
					</button>
				</div>
			</div>
		</div>
		<div class="card mt-2">
			<div class="card__content">
				<div class="row">
					<div class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field">
                <VueCtkDateTimePicker 
									id="fecha" 
									v-model="form.fecha" 
									locale="es" 
									only-date no-label
                  button-now-translation="Ahora" 
									format="YYYY-MM-DD" 
									formatted="YYYY-MM-DD"
                  label="Seleccione fecha..." 
								/>
                <label>Fecha:</label>
              </div>
            </div>
          </div>
					<div class="col-xs-12 col-md-6">
						<div class="form-field select2 select2-field--stretch">
              <div class="select2-field">
                <v-select 
									:filterable="false" 
									@input="inputBodega" 
									label="descripcion" 
									placeholder="Seleccione..."
                  :options="bodegas" 
									id="bodegas" 
									v-model="selectedBodega"
								></v-select>
                <label for="bodegas">Sucursal</label>
              </div>
            </div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		bodegas: {
			type: Array,
			required: false,
			default: function () {
				return [];
			}
		}
	},
	data: function () {
		return {
			form: {
				fecha: moment(new Date()).format('YYYY-MM-DD'),
				exportar: 'N',
				bodega_id: null,
			},
			selectedBodega: null,
		}
	},
	methods: {
		inputBodega: function() {
			if (this.selectedBodega != null)
				this.form.bodega_id = this.selectedBodega.id;
			else
				this.form.bodega_id = null;
		},
		validarFormulario: function() {
			if(this.form.fecha == null){
				swal.fire('Aviso', 'Debe seleccionar una fecha para generar el reporte', 'warning');
				return false;
			}
			if(this.form.bodega_id == null){
				swal.fire('Aviso', 'Debe seleccionar una sucursal para generar el reporte', 'warning');
				return false;
			}
			return true;
		},
		exportar: function() {
			if(!this.validarFormulario())
				return;
			this.form.exportar = 'E';
      window.open(url + '/reporte-general-cartera' + this.serialize(this.form), '_blank');
		},
		serialize: function (obj) {
      return (
        "?" +
        Object.keys(obj)
          .reduce(function (a, k) {
            let val = obj[k];
            let esArray = false;
            if (val instanceof Date) {
              val = val.toLocaleDateString("en");
            } else if (val instanceof Array) {
              esArray = true;
              let acumulador = "";
              for (let i = 0; i < val.length; i++) {
                acumulador += k + "%5B%5D=" + val[i];
                if (i != val.length - 1) {
                  acumulador += "&";
                }
              }
              val = acumulador;
              a.push(val);
            }
            if (!esArray) a.push(k + "=" + encodeURIComponent(val));
            return a;
          }, [])
          .join("&")
      );
    },
	},
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/pedidos/ReporteGeneralCartera.vue